import { useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes
} from 'react-router-dom'
import LoginPage from './pages/LoginPage/LoginPage'
import Layout from './layout/Layout'
import { AccessForbiddenPage } from './pages/AccessForbiddenPage'
import CssBaseline from '@material-ui/core/CssBaseline'
import { ModalContainer } from './components/ModalContainer'
import { client } from './client'
import { ErrorBoundary } from 'react-error-boundary'
import authenticationService from './services/AuthenticationService'
import { useTranslation } from 'react-i18next'

const ErrorFallback = ({ error }: { error: Error }) => {
  const { t } = useTranslation('errorFallbackApp')

  // check if error is usable
  if (!error) return <></>
  if (!(error instanceof Error)) return <></>

  console.log('got an error', error)

  switch (error.name) {
    case 'NotAuthenticatedException':
      authenticationService.logout()
      return <></>
    default:
      return (
        <div>
          <h3>
            {t('errorMessage')} {error.name}
          </h3>
          <pre style={{ color: 'red' }}>{error.message}</pre>
        </div>
      )
  }
}

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  return client.isLoggedIn() ? <>{children}</> : <Navigate to="/login" replace />
}

const App = () => {
  const [accessible, setAccessible] = useState<boolean | null>(null)
  const [currentIpAddress, setCurrentIpAddress] = useState<string>()

  useEffect(() => {
    client.isAccessible().then(({ accessible, ipAddress }) => {
      setAccessible(accessible)
      if (ipAddress) {
        setCurrentIpAddress(ipAddress)
      }
    })
  }, [])

  if (accessible === null) {
    return null
  }

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => (window.location.href = '/')}
    >
      <CssBaseline />
      <ModalContainer />
      <Router>
        <Routes>
          {!accessible ? (
            <Route
              path="*"
              element={<AccessForbiddenPage ipAddress={currentIpAddress} />}
            />
          ) : (
            <>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              />
            </>
          )}
        </Routes>
      </Router>
    </ErrorBoundary>
  )
}

export default App
